import { Booth } from '../models/booth';
import { AudioVisitation } from '../models/visitation';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const audioVisitation = (siteApi: IApiService) => ({
  index: (params?): Promise<IPaginatedResponse<AudioVisitation>> => {
    return siteApi.get('/audio-visitation', { params });
  },
  get: (id) => {
    return siteApi.get(`/audio-visitation/${id}`);
  },
  booth: {
    index: (params): Promise<Booth[]> => {
      return siteApi.get('/audio-visitation/booth', { params });
    }
  }
});
